import { component$ } from "@builder.io/qwik";
import { Link } from "@builder.io/qwik-city";
import { type TIconName } from "~/lib/icon-names";
import { NamedIcon } from "./named-icon";

export const SocialLink = component$<{
  href: string;
  prefix?: string;
  icon: TIconName;
  ariaLabel?: string;
}>(({ href, prefix, icon, ariaLabel }) => {
  const fullHref = (() => {
    if (href.startsWith("https://")) {
      return href.split(/[ ;,]+/)[0].trim();
    } else if (href.startsWith("www.") || href.match(/\.\w{1,10}$/)) {
      return `https://${href.split(/[ ;,]+/)[0].trim()}`;
    }

    return `${prefix ?? ""}${href.replaceAll(/\W+/gi, "")}`;
  })();

  return (
    <Link
      href={fullHref}
      target="_blank"
      aria-label={ariaLabel}
      class="flex h-10 w-10 items-center justify-center rounded-lg bg-gray-100 text-purple-700 transition-colors hover:bg-white hover:text-purple-500"
    >
      <NamedIcon name={icon} class="h-4 w-4" />
    </Link>
  );
});
